export const partyColumns = [
  "CDU",
  "Die.Linke",
  "SPD",
  "AfD",
  "Grüne",
  "NPD",
  "FDP",
  "Freie.Wähler",
  "Familie",
  "Tierschutzpartei",
  "Piraten",
  "Die.Partei",
  "Volksabstimmung",
  "ÖDP",
  "MLPD",
  "DKP",
  "BP",
  "SGP",
  "Tierschutz.hier",
  "Tierschutzallianz",
  "Bündnis.C",
  "BIG",
  "BGE",
  "Die.Direkte",
  "DieM25",
  "III.Weg",
  "Die.Grauen",
  "Die.Rechte",
  "Die.Violetten",
  "Liebe",
  "Die.Frauen",
  "Graue.Panther",
  "LKR",
  "Menschliche.Welt",
  "NL",
  "ÖkoLinX",
  "Die.Humanisten",
  "Partei.für.die.Tiere",
  "Gesundheitsforschung",
  "Volt"
];

export const partyColumnsComp = partyColumns.map(c => `${c}_Vergleich`);
export const invalidVotesColumn = 'Ungültige.Stimmen';
export const invalidVotesColumnComp = `${invalidVotesColumn}_Vergleich`;
export const validVotesColumn = 'Gültige.Stimmen';
export const validVotesColumnComp = `${validVotesColumn}_Vergleich`;
export const allVotesColumn = 'Wahlberechtigte';
export const allVotesColumnComp = `${allVotesColumn}_Vergleich`;
export const topParties = partyColumns.slice(0, 6);
export const cduShortName = 'CDU';


export const numColumns = [
  ...partyColumns,
  ...partyColumnsComp,
  invalidVotesColumn,
  invalidVotesColumnComp,
  validVotesColumn,
  validVotesColumnComp,
  allVotesColumn,
  allVotesColumnComp
];

export const partyConfig = {
  CDU: {
    min: '#7f7f7f',
    max: '#373737',
    name: 'CDU/CSU',
    shortname: cduShortName
  },
  SPD: {
    min: '#ff978a',
    max: '#DB4240',
    name: 'SPD'
  },
  'Die.Linke': {
    min: '#ed7abd',
    max: '#96276E',
    name: 'Linke'
  },
  'Grüne': {
    min: '#9ff792',
    max: '#4BA345',
    name: 'Grüne'
  },
  AfD: {
    min: '#CEE9FF',
    max: '#009de0',
    name: 'AfD'
  },
  Piraten: {
    min: '#FFC28D',
    max: '#f68920',
    name: 'Piraten'
  },
  FDP: {
    min: '#ffff70',
    max: '#F6BB00',
    name: 'FDP'
  },
  'Die.Partei': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Partei'
  },
  'Partei.für.die.Tiere': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Partei für die Tiere'
  },
  'III.Weg': {
    min: '#EBEBEB',
    max: '#888',
    name: 'III. Weg'
  },
  'ÖkoLinX': {
    min: '#EBEBEB',
    max: '#888',
    name: 'ÖkoLinX'
  },
  'Die.Rechte': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Die Rechte'
  },
  'Freie.Wähler': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Freie Wähler'
  },
  'Bündnis.C': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Bündnis C'
  },
  'Menschliche.Welt': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Menschliche Welt'
  },
  'Tierschutz.hier': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Tierschutz hier'
  },
  'Die.Direkte': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Die Direkte'
  },
  'Die.Grauen': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Die Grauen'
  },
  'Die.Violetten': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Die Violetten'
  },
  'Die.Frauen': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Die Frauen'
  },
  'Graue.Panther': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Graue.Panther'
  },
  'Die.Humanisten': {
    min: '#EBEBEB',
    max: '#888',
    name: 'Die Humanisten'
  },
  sonstige: {
    min: '#EBEBEB',
    max: '#888',
    name: 'Sonstige',
    shortname: 'Sonst.'
  },
  nichtwaehler: {
    min: '#7defe5',
    max: '#129B93',
    name: 'Nichtwähler'
  },
  default: {
    min: '#EBEBEB',
    max: '#888',
  }
};

export function getPartyColor(partyName) {
  return partyConfig[partyName] ? partyConfig[partyName] : partyConfig.default;
}

export function getPartyName(partyName) {
  return partyConfig[partyName] ? partyConfig[partyName].name : partyName;
}

export function getPartyNameShort(partyName, areaId = '') {
  if (partyName === 'CDU' && areaId.substr(0, 2) === '09' && baseconfig.app.unionShortName) {
    return 'CSU'
  }
  if (partyConfig[partyName]) {
    return partyConfig[partyName].shortname ? partyConfig[partyName].shortname : partyConfig[partyName].name;
  }

  return partyName;
}